module.exports = __webpack_public_path__ + "static/media/logo-디아이티@2x.14d7b8c7.png";